module.exports = __webpack_public_path__ + "img/conteudoGratuito-v2.436ac818.png";